import { useState, useEffect } from 'react';
import { Log } from '../../util';
export default function useAsync(fn) {
    var _a = useState({
        loading: true,
    }), state = _a[0], set = _a[1];
    var callback = function () {
        fn().then(function (value) {
            set({
                loading: false,
                data: value,
            });
        }, function (error) {
            set({
                loading: false,
            });
            Log.error(error);
        });
    };
    useEffect(function () {
        callback();
    }, [fn]);
    return state;
}
